import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../../../Components/Utility/CustomPagination";
import { SkeletonNotification } from "../../../../Components/Utility/Skeletons";
import { fetchCmsMetaData } from "../../../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../../../Components/Utility/setMetaTags";

function HostNotification() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); 
    const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 4;
const [meta,setMeta] = useState();
  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/host/get-notifications?page=${currentPage}&per_page=${limit}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );

        if (res.data?.data) {
          setNotifications(res.data.data);
           if (res.data.pagination) {
            setCurrentPage(res.data.pagination.current_page);
            setTotalPages(res.data.pagination.last_page);
          } else if (res.data.meta) {
            // in case your API uses "meta"
            setCurrentPage(res.data.meta.current_page);
            setTotalPages(res.data.meta.last_page);
          }
        }
      } catch (err) {
        console.error("GET /host/get-notifications error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNotification();
  }, [currentPage]);
  // ------------------------------
  // WHEN CLICK → FIRST READ → THEN NAVIGATE
  // ------------------------------
  const handleNotificationClick = async (bookingId) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE}/host/read-notification`,
        { booking_id: bookingId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      // console.log("Notification marked as read:", bookingId);

      // Now navigate to detail page
      navigate(`/host-experience-detail/${bookingId}`);

    } catch (err) {
      console.error("Read notification error:", err);
      // Even if API fails, navigate (optional)
      navigate(`/host-experience-detail/${bookingId}`);
    }
  };
  // ------------------------------

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };


  useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("notification");
      setMeta(data);
    };

    loadMeta();
  }, []);
  return (
    <section className="mng_bottomss user_allls profiles all_titless myprofiless al_bootm_spance">
       <SetMetaTags
        title= {meta?.meta_title || "Notification | Weyfarin"}
        description={meta?.meta_description || "Notification | Weyfarin"}
      
      />
      <div className="prfo_listst lastsst al_sec_ctxt ac_settingss">
        <div className="row">
          <div className="col-lg-12">
            <div className="discriptionns">
              <h3>Notification</h3>
            </div>

            {loading && (
              <>
                <SkeletonNotification />
                <SkeletonNotification />
                <SkeletonNotification />
              </>
            )}

            {!loading && notifications.length === 0 && (
              <p>No notifications found.</p>
            )}

            {/* <div className="form_al_fildss notifications">
				    <div className="main_ntf_area">
						<div className="nt_listing">
							<div className="mg_icons"><i className="fa fa-bell-o"></i></div>
							<div className="red_contct">
								<p>dfsfasfa</p>
								<span>9/26/2025</span>
							</div>
						</div>
					</div>
                </div> */}
            <div className="form_al_fildss notifications">
              <div className="main_ntf_area">
                {notifications.map((item) => (
                  <div className={`nt_listing ${item.is_host_read === 0 ? "unreadNotification" : ""}`}
                   key={item.id}  
                   onClick={() => handleNotificationClick(item.booking_id)} // <-- CLICK EVENT
                   >
                    <div className="mg_icons">
                      <i className="fa fa-bell-o"></i>
                    </div>

                    <div className="red_contct">
                      <p>
                        {item.first_name} booked: {item.experience_title}
                      </p>
                      <small>Booking ID: {item.booking_id}</small>
                      <br />
                      <span>{new Date(item.read_at).toLocaleString()}</span>
                    </div>
                  </div>
                ))}

                <CustomPagination
                  currentPage={currentPage}
                  lastPage={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HostNotification;
